import { useEffect, useState } from "react";
import API from "../../api/api";
import { PartidoAdmin } from "../../models/PartidoAdmin";



const ResultadoPartidos = () => {
  const [partidos, setPartidos] = useState<PartidoAdmin[]>([]);
  const [editando, setEditando] = useState<Record<number, { gl: number; gv: number }>>({});
  const [penales, setPenales] = useState<
  Record<number, { pl: number; pv: number; ganador: number }>
>({});


  const cargarPartidos = async () => {
    const res = await API.get("/admin/liquidar-partido");
    setPartidos(res.data);
  };

  useEffect(() => {
    cargarPartidos();
  }, []);

  const guardarResultado = async (id: number) => {
    const data = editando[id];
    if (!data) return;

    await API.put(`/admin/liquidar-partido/${id}/resultado`, {
      goles_local: data.gl,
      goles_visitante: data.gv,
    });

    cargarPartidos();
  };

 const liquidar = async (id: number) => {
  if (!window.confirm("¿Liquidar partido y repartir puntos?")) return;
  
  try {
    await API.post(`/admin/liquidar-partido/${id}/liquidar`);
    alert("Partido liquidado correctamente");
    cargarPartidos(); // recargar lista
  } catch (err) {
    alert("Error al liquidar: " + err);
  }
};
const guardarPenales = async (id: number) => {
  const data = penales[id];
  if (!data) return;

  try {
    await API.post(`/admin/partidos/${id}/penales`, {
      penales_local: data.pl,
      penales_visitante: data.pv,
      ganador_id: data.ganador,
    });

    alert("Penales guardados");
    cargarPartidos();
  } catch (err: any) {
    alert(err.response?.data?.error || "Error al guardar penales");
  }
};

const cerrarGrupos = async () => {
  if (!window.confirm("⚠️ Esto cerrará la fase de grupos y liquidará TODAS las predicciones. ¿Continuar?")) return;

  try {
    await API.post("/admin-drag/cerrar-grupos");

    // 👉 GENERAR 16avos automáticamente
    await API.post("/dieciseis/generar-dieciseisavos");
    await cargarPartidos();

    alert("✅ Fase de grupos cerrada y 16avos generados");
  } catch (err: any) {
    alert("❌ Error: " + (err.response?.data?.error || err.message));
  }
};


  return (
    <div>
      <h1>Resultados de Partidos</h1>

        {/* 🔒 BOTÓN GLOBAL */}
    <div style={{ marginBottom: 20 }}>
      <button
        onClick={cerrarGrupos}
        style={{
          background: "#8b0000",
          color: "white",
          padding: "10px 16px",
          fontWeight: "bold",
          borderRadius: 6,
        }}
      >
        🔒 Cerrar fase de grupos
      </button>
    </div>

      {partidos.map(p => (
        
        <div key={p.id} style={{ border: "1px solid #ccc", marginBottom: 10, padding: 10 }}>
          <strong>{p.local_nombre}</strong>

          <input
            type="number"
            value={editando[p.id]?.gl ?? p.goles_local ?? ""}
            onChange={e =>
              setEditando({
                ...editando,
                [p.id]: { gl: +e.target.value, gv: editando[p.id]?.gv ?? 0 }
              })
            }
            disabled={p.liquidado}
          />

          vs

          <input
            type="number"
            value={editando[p.id]?.gv ?? p.goles_visitante ?? ""}
            onChange={e =>
              setEditando({
                ...editando,
                [p.id]: { gv: +e.target.value, gl: editando[p.id]?.gl ?? 0 }
              })
            }
            disabled={p.liquidado}
          />

          <strong>{p.visitante_nombre}</strong>

          <div>
            Estado: {p.estado} | Liquidado: {p.liquidado ? "✅" : "❌"}
          </div>

          {!p.liquidado && (
            <>
              <button onClick={() => guardarResultado(p.id)}>
                Guardar resultado
              </button>

             {p.estado === "finalizado" && (
              <button onClick={() => liquidar(p.id)}>
                Liquidar
              </button>
            )}
            </>
          )}
          {p.estado === "finalizado" &&
 p.goles_local === p.goles_visitante &&
 !p.ganador_id &&
 !p.liquidado && (
  <div style={{ marginTop: 10, padding: 10, border: "1px dashed #999" }}>
    <strong>Definir penales</strong>

    <div>
      <input
        type="number"
        placeholder="Penales local"
        onChange={e =>
          setPenales({
            ...penales,
            [p.id]: {
              ...penales[p.id],
              pl: +e.target.value,
              ganador: penales[p.id]?.ganador,
            },
          })
        }
      />

      <input
        type="number"
        placeholder="Penales visitante"
        onChange={e =>
          setPenales({
            ...penales,
            [p.id]: {
              ...penales[p.id],
              pv: +e.target.value,
              ganador: penales[p.id]?.ganador,
            },
          })
        }
      />
    </div>

    <div style={{ marginTop: 5 }}>
      <label>
        <input
          type="radio"
          name={`ganador-${p.id}`}
          onChange={() =>
            setPenales({
              ...penales,
              [p.id]: { ...penales[p.id], ganador: p.id_local },
            })
          }
        />
        Gana {p.local_nombre}
      </label>

      <label style={{ marginLeft: 10 }}>
        <input
          type="radio"
          name={`ganador-${p.id}`}
          onChange={() =>
            setPenales({
              ...penales,
              [p.id]: { ...penales[p.id], ganador: p.id_visitante },
            })
          }
        />
        Gana {p.visitante_nombre}
      </label>
    </div>

    <button onClick={() => guardarPenales(p.id)}>
      Guardar penales
    </button>
  </div>
)}

        </div>
      ))}
    </div>
  );
};



export default ResultadoPartidos;
